<template>
  <myhead @next="next">{{ $route.query.title || $route.meta.title }}</myhead>
  <ul class="mt20">
    <li v-for="(item, index) in list" :key="index">
      <dl class="pad15">
        <dd>
          <div class="flex between mb10"><span></span><img @click="handleDelAddress(item.id)" class="height14px" src="@/assets/img/icon32.png" alt="">
          </div>
          <div class="flex between" @click="handleOrder(item.id)">
            <p class="flex mr8 size16 ">
              <span class="address_name mr5">{{ item.consignee }}</span>{{ item.mobile }}
            </p>
            <van-tag plain type="danger" v-if="item.is_default">默认</van-tag>
          </div>
          <p class="ellipsis2 size14 C888 mt8">
            {{ item.address }}
          </p>
        </dd>
        <dt class="mt14 flex between size12">
          <p v-if="item.is_default === 1" class="Cccc flex">
            <van-icon name="checked" class="Cred mr4 size20" />
            <span>已默认</span>
          </p>
          <p v-else class="Cccc flex" @click.stop="setDefault(item.id, item.is_default)">
            <van-icon name="circle" class="C888 mr4 size20" />默认
          </p>
          <div class="flex size20">
            <!-- <van-icon
              name="back-top"
              class="C999"
              @click="setDefault(item.id, item.is_default)"
            /> -->
            <!-- <van-icon name="delete-o" class="ml10 C999" @click="handleDelAddress(item.id)" /> -->
            <span class="size12 ml14 " @click="$router.push({ path: '/address/edit',query:{type:'edit',addressInfo: JSON.stringify(item)} })">编辑 <img
                src="@/assets/img/icon77.png" class="height18px" alt=""></span>
          </div>
        </dt>
      </dl>
      <hr class="opacity4 mb10 mt10" />
    </li>
  </ul>
  <div class="pad40"></div>
  <div class="pad15 fixed l r b mb10">
    <van-button round type="primary" block @click="$router.push({ path: '/address/edit' })">+新增收货地址信息</van-button>
  </div>
</template>

<script>
import ajax from "@/utils/request.js";
import { showToast } from "vant";
export default {
  data () {
    return {
      list: [],
    };
  },
  watch: {},
  methods: {
    setDefault (id, isDefault) {
      if (isDefault === 1) {
        return;
      }
      const data = {
        id: id,
      };
      ajax.post("users/setdefault", data).then((res) => {
        if (res.errcode === 1) {
          ajax.post("users/addresslist").then((res) => {
            this.list = res.data;
          });
        }
      });
    },
    next () {
      history.forward();
    },
    handleDelAddress (id) {
      console.log(id);
      const that = this;
      const data = {
        id: id,
      };
      this.showDialog({
        closeOnPopstate: true,
        closeOnClickOverlay: true,
        confirmButtonText: "确认删除",
        message: "是否删除地址",
      }).then(() => {
        ajax
          .post("users/deladdress", data)
          .then((res) => {
            if (res.errcode === 1) {
              showToast("删除成功");
            }
          })
          .then(() => {
            ajax.post("users/addresslist").then((res) => {
              that.list = res.data;
            });
          });
      });
    },
    handleOrder (id) {
      if (this.$route.query.type === 'order') {
        // 从确认订单项选择地址
        this.$router.push({ path: '/shop/order/confirm', query: { addressid: id } })
      }else if (this.$route.query.type === 'auction') {
        // 拍卖商品付款页
        this.$router.push({ path: '/shop/order/auction', query: { addressid: id,order_id:this.$route.query.order_id} })
      }else if (this.$route.query.type === 'select') {
        const data = {
          id: this.$route.query.id,
          address_id: id
        }
        ajax.post("order/setaddress", data).then(res => {
          if (res.errcode == 1) {
            showToast(res.message)
            this.$router.go(-1)
          }
        })
      } else {
        return
      }
    }
  },
  created () {
    ajax.post("users/addresslist").then((res) => {
      this.list = res.data;
    });
  },
};
</script>

<style>
.address_name{
  display: block;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
